import {createStyles} from '@mantine/core';
import React, {ReactNode} from 'react';

import {Header2} from 'ui-library/Headers';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import {Optional} from 'util/Types';

interface SectionProps {
  title: string;
  icon?: Optional<string>;
  children: ReactNode;
}

export default function Section({title, icon, children}: SectionProps): JSX.Element {
  const {classes} = useStyles();
  return (
    <div>
      <div className={classes.sectionHeaderContainer}>
        <Header2 className={classes.sectionHeader}>
          {icon && <BenchlingIcon icon="lock" className={classes.sectionIcon} />}
          {title}
        </Header2>
        <hr className={classes.sectionHeaderRule} />
      </div>
      {children}
    </div>
  );
}

const useStyles = createStyles((theme) => ({
  sectionHeaderContainer: {
    display: 'flex',
    alignItems: 'flex-end', // Effect: <hr> is aligned with the center of the <h2> text.
    gap: theme.spacing.xs,
    marginTop: theme.spacing.xl,
    marginBottom: theme.spacing.xs,
  },
  sectionHeader: {
    flex: 'none',
  },
  sectionHeaderRule: {
    flex: '1',
    borderTopWidth: 2,
  },
  sectionIcon: {
    marginRight: theme.spacing.sm,
  },
}));
